import { RootState } from '@/store';

import { GetterTree } from 'vuex';
import { State } from './state';
import { TeilnehmerAntwort } from '@/models/TeilnehmerAntwortModels';
import { BewertungAntwort, UmfrageInfo } from '@/models/UmfrageModels';

export type Getters = {
  teilnehmerantworten(state: State): Array<TeilnehmerAntwort>;
  bewertungantworten(state: State): Array<BewertungAntwort>;
  umfrageInfo(state: State): UmfrageInfo | null;
};

export const getters: GetterTree<State, RootState> & Getters = {
  teilnehmerantworten(state: State) {
    return state.teilnehmerantworten;
  },

  bewertungantworten(state: State) {
    return state.bewertungantworten;
  },

  umfrageInfo(state: State) {
    return state.umfrageInfo;
  },
};
